angular.module( 'acme.view.application.pos.create.pages.forms.standard', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.standard.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesFormsStandard = {
        name: 'application.pos.create.pages.forms.standard',
        url: '/standard',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesFormsStandardController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/standard/standard.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(posCreatePagesFormsStandard);
});
